import { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EmailPreview } from '@/components/email/EmailPreview';

// Display-only preview of the medical-staff withdrawal-result email. Mirrors
// StaffInviteEmailPage's toggle layout. The email body is the BE single-owner render
// (GET /admin/email-previews/staff-withdrawal-{approve|reject}, from messages_ko) —
// the FE never builds its own template. The email itself is auto-sent by the BE when an
// admin approves/rejects a request (PRD 03 §3.8 v1.3), so this page has no Send action;
// the toolbar only toggles which outcome to preview. `?result=rejected` starts in rejection mode.
//
// Canonical URL: `#/staff-withdraw-result-email` (matches prototype institution-managers.html
// + prototype/pages/staff-withdraw-result-email.html). Reached from the edit-panel preview link.

export function StaffWithdrawResultEmailPage() {
  const { t } = useTranslation('admin');
  const [searchParams] = useSearchParams();
  const [isRejected, setIsRejected] = useState(
    searchParams.get('result') === 'rejected',
  );

  const kind = isRejected
    ? 'staff-withdrawal-reject'
    : 'staff-withdrawal-approve';

  return (
    <div className="admin-email-preview-page">
      <div className="admin-email-preview-page__back">
        <Link to="/medical-staff-management">
          {t('medicalStaffManagement.withdrawResultEmailPreview.backToList')}
        </Link>
      </div>

      <div className="email-preview-toolbar">
        <span className="email-preview-toolbar__label">
          {t('medicalStaffManagement.withdrawResultEmailPreview.toolbarLabel')}
        </span>
        <div className="email-preview-toolbar__seg">
          <button
            type="button"
            className={isRejected ? '' : 'is-active'}
            onClick={() => setIsRejected(false)}
          >
            {t('medicalStaffManagement.withdrawResultEmailPreview.modeApproved')}
          </button>
          <button
            type="button"
            className={isRejected ? 'is-active' : ''}
            onClick={() => setIsRejected(true)}
          >
            {t('medicalStaffManagement.withdrawResultEmailPreview.modeRejected')}
          </button>
        </div>
      </div>

      <EmailPreview kind={kind} />
    </div>
  );
}
